import { ListTicketsPayload } from '../types';

export const helpdeskQueryKeys = {
  all: ['helpdesk'] as const,
  tickets: () => [...helpdeskQueryKeys.all, 'tickets'] as const,
  ticketList: (filters: ListTicketsPayload) =>
    [...helpdeskQueryKeys.tickets(), 'list', filters] as const,
  ticketDetail: (id: string) => [...helpdeskQueryKeys.tickets(), 'detail', id] as const,
  comments: (ticketId: string) => [...helpdeskQueryKeys.all, 'comments', ticketId] as const,
  notifications: () => [...helpdeskQueryKeys.all, 'notifications'] as const,
  users: (name: string, role?: string[]) =>
    [...helpdeskQueryKeys.all, 'users', name, role] as const,
  analytics: {
    summary: () => [...helpdeskQueryKeys.all, 'analytics', 'summary'] as const,
    volume: (days: number) => [...helpdeskQueryKeys.all, 'analytics', 'volume', days] as const,
    byCategory: () => [...helpdeskQueryKeys.all, 'analytics', 'byCategory'] as const,
    resolutionTime: () => [...helpdeskQueryKeys.all, 'analytics', 'resolutionTime'] as const,
    topResolvers: () => [...helpdeskQueryKeys.all, 'analytics', 'topResolvers'] as const
  }
};
